interface SpeedTestCardsProps {
  ping: number;
  download: number;
  upload: number;
  activePing?: boolean;
  activeDl?: boolean;
  activeUl?: boolean;
}

export function SpeedTestCards({
  ping,
  download,
  upload,
  activePing,
  activeDl,
  activeUl,
}: SpeedTestCardsProps) {
  const Card = ({ icon, label, value, unit, active, color }: any) => (
    <div
      className={`bg-[hsl(var(--st-surface-1))] border border-[hsl(var(--st-border))] rounded-lg p-3 flex flex-col items-center gap-1 transition-all ${
        active
          ? `border-[${color}] shadow-lg`
          : ''
      }`}
      style={{
        '--card-color': color,
      } as React.CSSProperties}
    >
      <div className="text-lg leading-none">{icon}</div>
      <div className="text-xs text-[hsl(var(--st-dim))] uppercase tracking-widest">
        {label}
      </div>
      <div className="font-bold text-2xl text-white">
        {value === 0 || value === -1 ? '—' : value < 10 ? value.toFixed(1) : Math.round(value)}
      </div>
      <div className="text-xs text-[hsl(var(--st-dim))]">{unit}</div>
    </div>
  );

  return (
    <div className="grid grid-cols-3 gap-2">
      <Card
        icon="⚡"
        label="Ping"
        value={ping}
        unit="ms"
        active={activePing}
        color="hsl(var(--st-pink))"
      />
      <Card
        icon="↓"
        label="Download"
        value={download}
        unit="Mbps"
        active={activeDl}
        color="hsl(var(--st-cyan))"
      />
      <Card
        icon="↑"
        label="Upload"
        value={upload}
        unit="Mbps"
        active={activeUl}
        color="hsl(var(--st-green))"
      />
    </div>
  );
}
